import React from "react";
import { PaymentErrorPage } from "./PaymentErrorPage";

export const PaymentErrorPageContainer: React.FC = () => {
  return <PaymentErrorPage />;
};
